// extracted by mini-css-extract-plugin
module.exports = {"atFilterArea":"AtMovieTab_atFilterArea__27EaD","atFilter":"AtMovieTab_atFilter__3IPCK","active":"AtMovieTab_active__3hKP5"};